import {
  CAPTCHA_KEY
} from './const';
import {
  checkPrivacy
} from './utils';

const captchaForms = document.querySelectorAll('.form-recaptcha');

captchaForms.forEach((recaptchaForm) => {
  addRecapthaHandler(recaptchaForm);
});

export function addRecapthaHandler(form) {
  form.addEventListener('click', loadRecaptchaHandler);

  if (form.classList.contains('form-recaptcha-auto')) {
    form.addEventListener('submit', recaptchaSendHandler);
  }
}

export function loadRecaptchaHandler() {
  if (typeof (grecaptcha) === 'undefined') {
    const grecaptchaScript = document.createElement('script');
    grecaptchaScript.src = (
      `https://www.google.com/recaptcha/api.js?render=${CAPTCHA_KEY}`);
    document.body.insertAdjacentElement('beforeend', grecaptchaScript);
  }
}

export function recaptchaSendHandler(evt) {
  return new Promise((onLoad, onError) => {
    const form = evt.target;
    const actionName = form.id.replace('-', '').toLowerCase();
    const button = form.querySelector('button[type="submit"]');

    evt.preventDefault();

    const privacyStatus = checkPrivacy(form);

    if (!privacyStatus) {
      return;
    }

    if (form.classList.contains('form-recaptcha-auto')) {
      button.disabled = true;
    }
    // eslint-disable-next-line no-undef
    grecaptcha.ready(function () {
      // eslint-disable-next-line no-undef
      grecaptcha.execute(CAPTCHA_KEY, {
        action: actionName
      }).then(function (token) {
        form.querySelector('input[name=g-recaptcha-response]').value = token;
        if (form.classList.contains('form-recaptcha-auto')) {
          form.submit();
        }
        return onLoad(form);
      }).catch(function (err) {
        if (form.classList.contains('form-recaptcha-auto')) {
          button.disabled = false;
        }
        return onError(err);
      });
    });
  });
}
